import React from 'react';
import { BtnContainer } from './style';

const RoundedBorderLeftIconBtn = ({ leftIcon, btnText, onclick }) => {
  return (
    <BtnContainer onClick={onclick}>
      {leftIcon && <img src={leftIcon} />}
      <span data-dd-privacy={btnText === 'New Task' ? 'mask-user-input' : undefined}>{btnText}</span>
    </BtnContainer>
  );
};

export default RoundedBorderLeftIconBtn;
